import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const ListIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="list" {...props} />;
};

export { ListIcon };
